export default function MobileBurgerMenu() {
	// mobile burger menu
	let burger = document.querySelector( '.burger-button' );
	let menu_body = document.querySelector( '#header-menu' );
	const body = document.querySelector( 'body' );
	if ( burger ) {
		burger.onclick = function () {
			body.classList.toggle( 'open' );
			menu_body.classList.toggle( 'active' );
			burger.classList.toggle( 'active' )
		}
	}
}